/**
 *  @class
 *  @function BackgroundVideo
 */
if (!customElements.get('background-video')) {
  class BackgroundVideo extends HTMLElement {
    constructor() {
      super();

      this.tl = false;
      this.splittext = false;
    }

    connectedCallback() {
      let _this = this;

      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.prepareAnimations();
      }

      // Video Support.
      let video_container = this.querySelector('.background-video__iframe');
      if (video_container) {
        const iframe = video_container.querySelector('iframe');
        if (iframe) {
          iframe.onload = function () {
            _this.videoPlay(video_container);
          };
        }
      }
    }

    disconnectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.tl.kill();
        this.splittext.revert();
      }
    }

    videoPlay(video_container) {
      setTimeout(() => {
        const iframe = video_container.querySelector('iframe');
        if (!iframe) return;

        if (video_container.dataset.provider === 'youtube') {
          iframe.contentWindow.postMessage(
            JSON.stringify({
              event: "command",
              func: "playVideo",
              args: ""
            }),
            "*"
          );
        } else if (video_container.dataset.provider === 'vimeo') {
          iframe.contentWindow.postMessage(
            JSON.stringify({
              method: "play"
            }),
            "*"
          );
        }
      }, 10);
    }

    prepareAnimations() {
      let section = this,
          button_offset = 0;

      section.tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top center"
        }
      });

      document.fonts.ready.then(function () {
        section.splittext = new SplitText(section.querySelectorAll('h3, p'), {
          type: 'lines, words',
          linesClass: 'line-child'
        });

        if (section.querySelector('h3')) {
          let h3_duration = 0.7 + ((section.querySelectorAll('h3 .line-child div').length - 1) * 0.05);
          section.tl.from(section.querySelectorAll('h3 .line-child div'), {
            duration: h3_duration,
            yPercent: '100',
            stagger: 0.05
          }, 0);
          button_offset += h3_duration;
        }

        if (section.querySelector('p')) {
          let p_duration = 0.7 + ((section.querySelectorAll('p .line-child div').length - 1) * 0.02);
          section.tl.from(section.querySelectorAll('p .line-child div'), {
            duration: p_duration,
            yPercent: '100',
            stagger: 0.02
          }, 0);
          button_offset += p_duration;
        }

        if (section.querySelector('.video-lightbox-modal__button')) {
          section.tl.fromTo(section.querySelector('.video-lightbox-modal__button'), {
            autoAlpha: 0
          }, {
            duration: 0.5,
            autoAlpha: 1
          }, button_offset * 0.4);
        }
      });
    }
  }

  customElements.define('background-video', BackgroundVideo);
}

/* -------------------------------------------------------------------------- */
/*   Detect autoplay block and show poster                                     */
/* -------------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  const videos = document.querySelectorAll('background-video');

  videos.forEach(wrapper => {
    const video = wrapper.querySelector('.background-video__iframe video');
    if (!video) return;

    // Mostra poster subito
    wrapper.classList.add('autoplay-disabled');

    // Prova ad avviare autoplay
    const attempt = video.play();
    if (attempt) {
      attempt.catch(() => {
        // Bloccato: poster rimane
        wrapper.classList.add('autoplay-disabled');
      });
    }

    // Detect playback in modo cross-browser:
    // appena currentTime aumenta → video sta andando davvero
    video.addEventListener('timeupdate', () => {
      if (video.currentTime > 0.05) {  // 1-2 frame bastano
        wrapper.classList.remove('autoplay-disabled');
      }
    });

    // Fallback: Firefox sometimes reports playing without event
    setTimeout(() => {
      if (video.currentTime > 0) {
        wrapper.classList.remove('autoplay-disabled');
      }
    }, 500);
  });
});